import AILOGO from "@/assets/record/ic_ai.svg";

const LogoHeader = () => {
  return (
    <div className="flex items-center px-6 py-3">
      <img className="w-10 h-10 mr-1" src={AILOGO} />
      <div className="text-5 font-500">MAXHUB AI会记</div>
    </div>
  );
};

export default LogoHeader;
